import controller from './task-list.controller';
import template from './task-list.view.html';

let TaskListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default TaskListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/task-list/task-list.component.js
 **/